import type * as React from "react";

type LandingLayoutProps = {
  children: React.ReactNode;
};

// react-doctor-disable-next-line react-doctor/only-export-components -- Pages Router layout module: the component is co-located with its required getLayout export.
function LandingLayout({ children }: LandingLayoutProps) {
  return <div>{children}</div>;
}

export const getLayout = (page: React.ReactElement) => (
  <LandingLayout>{page}</LandingLayout>
);
